const VolcaBassDefaultPatch = {
    meta: {
        id: "id000000",
        name: "Defult Patch",
        dateCreated: new Date().toLocaleDateString()
    },
    data: {
        octave: 63,
        peak: 0,
        cutoff: 64,
        rate: 0,
        int: 0,
        pitch1: 64,
        pitch2: 64,
        pitch3: 64,
        volume: 127,
        tempo: 64,
        attack: 0,
        decay: 127,
        egInt: 64,
        funcM1: true,
        funcM2: false,
        funcM3: false,
        funcM4: false,
        funcM5: false,
        funcM6: true,
        funcM7: false,
        funcM8: false,
        func9: false,
        func10: true,
        func11: false,
        func12: false,
        func13: false,
        func14: false,
        func15: false,
        func16: false,
    },
    cc: {
        octave: 40,
        rate: 41,
        int: 42,
        pitch1: 43,
        pitch2: 44,
        pitch3: 45,
        attack: 46,
        decay: 47,
        egInt: 48,     
    }
}

export default VolcaBassDefaultPatch;
